import moment from 'moment-timezone';
import { environment } from 'environments';

class ChatController {
  constructor($rootScope, $scope, $timeout, $interval, toastr, Messages, Users, Auth, $state, $filter) {
    'ngInject';

    Object.assign(this, {
      $scope,
      $rootScope,
      $timeout,
      $interval,
      $filter,
      toastr,
      Messages,
      Users,
      Auth,
      $state,
      patientId: parseInt($scope.ngDialogData.patient, 10),
      messages: [],
      beforeCursor: null,
      afterCursor: null,
      POLL_INTERVAL: 5000,
      listCategory: 'null',
      typingCounter: 0,
      message: '',
      modalOpen: false,
      boxMsgMaximized: false,
      timezone: $rootScope.timezones[0].timezone,
      BOD_2715: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
      //NOTE: Delete set-caret-position directive with LMNUK_1234 feature flag clean up...
      LMNUK_1234: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV), //New ticket is BOD_608...
      clinician: {},
      initialMessage: '',
      caretPosition: 0,
    });
    $scope.$on('$destroy', () => $interval.cancel(this.pollingInterval));
    $scope.$on('ngDialog.opened', this.initChatbox.bind(this));
    this.showSaveButton = false;
    this.getPatientDetails();
    this.getOlderMessages();
    this.getCategories();
    this.$filter = $filter;
  }

  formatDate(iso_date) {
    if (!iso_date) return null;
    const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
    return formatted_date;
  }

  toggleChatMsgBoxSize() {
    if (this.boxMsgMaximized) {
      $('#chat-dialog-body').addClass('hide-dialog-body');
      $('#chat-dialog-footer').addClass('increase-dialog-footer');
    } else {
      $('#chat-dialog-body').removeClass('hide-dialog-body');
      $('#chat-dialog-footer').removeClass('increase-dialog-footer');
    }
  }

  refreshChatWindowMessages() {
    this.messages = [];
    this.beforeCursor = null;
    this.getOlderMessages();
  }

  applyLocking(message) {
    // console.log("User is typing...");
    // console.log(message);
    // console.log(message.length);
    var patient = this.patientId;
    var this2 = this;
    var numCharCheckLocking = 5;
    var numChar;

    if (!message) {
      numChar = 1;
    } else {
      numChar = message.length + 1;
    }

    this.typingCounter++;

    if (this.typingCounter > numCharCheckLocking) {
      this.typingCounter = 1;
    }

    if (!this.modalOpen && (numChar === 1 || this.typingCounter >= numCharCheckLocking)) {
      this2.Messages.getMessagesLock(patient)
        .then(({ data }) => {
          this2.staffDetails = data; // IF LOCKED TO OTHER

          if (this2.staffDetails.clinician && this2.staffDetails.clinician.id != this2.Auth.profile.id) {
            this2.Users.getOne(patient)
              .then(({ data }) => {
                this2.patientDetails = data;

                if (!this2.modalOpen) {
                  this2.typingCounter = 0;
                  this2.modalOpen = true;
                  this2.Messages.callUnlockingModal(this2.staffDetails, this2.patientDetails, result => {
                    if (result) {
                      this2.Messages.setMessagesLock(patient)
                        .then(() => {
                          // JUST LET USER TO TYPE
                        })
                        .catch(err => {
                          // Error locking the messages
                          console.log('Error locking the messages');
                          console.log(err);
                        })
                        .finally(() => {
                          this2.modalOpen = false;
                        });
                    } else {
                      this2.modalOpen = false; // Closing the popup

                      console.log('Closing the popup'); // As Simon said, we do not want to "clear" the message when modal is dismissed
                      // So we comment this:
                      // this2.message = "";
                    }
                  });
                }
              })
              .catch(err => {
                // Error getting patient details
                console.log('Error getting patient details');
                console.log(err);
              });
          } else {
            // LOCKED TO HIMSELF
            this2.Messages.setMessagesLock(patient)
              .then(() => {
                // JUST LET USER TO TYPE
              })
              .catch(err => {
                // Error locking the messages
                console.log('Error locking the messages');
                console.log(err);
              });
          }
        })
        .catch(err => {
          // NO LOCKED
          this2.Messages.setMessagesLock(patient)
            .then(() => {
              // JUST LET USER TO TYPE
            })
            .catch(err => {
              // Error locking the messages
              console.log('Error locking the messages');
              console.log(err);
            });
        });
    }
  }

  goToUserDetails() {
    this.$state.go('userDetail', {
      id: this.patient.id,
    });
    this.$scope.closeThisDialog();
  }

  getPatientDetails() {
    // Manually set patient if it's a system message
    if (this.patientId === -1) {
      this.patient = {
        firstname: 'System',
        lastname: '',
      };
      return;
    }
    this.Users.getOne(this.patientId)
      .then(({ data }) => {
        this.patient = data;
        this.message = `Hello ${this.patient.firstname},\n\n`;
      })
      .then(() => {
        this.Users.getStaffUser(this.Auth.profile.id).then(({ data }) => {
          this.clinician = data;
          const defaultMessage = `Hello ${this.patient.firstname},\n\n`;
          this.initialMessage = defaultMessage;
          this.message = defaultMessage;
          this.caretPosition = this.initialMessage.indexOf(
            '\n',
            this.initialMessage.indexOf('\n', this.initialMessage.indexOf('\n') + 1) + 1,
          );
        });
      });
  }

  enableChangeCaretCheck(initial, current) {
    return initial === current;
  }

  getOlderMessages() {
    this.loading = true;
    this.Messages.getThread(this.patientId, {
      before: this.beforeCursor,
    })
      .then(({ data }) => {
        data.data.forEach(eachMessage => {
          eachMessage.tempMessageCategoryName = eachMessage.category_name;

          if (eachMessage.category_name == null) {
            eachMessage.showSaveButton = false;
          } else {
            eachMessage.showSaveButton = true;
          }
        });
        this.messages = this.messages.concat(data.data);
        this.metaData = data['metadata']; // THIS IS TO REFRESH PIMS "new message icon" IN THE VISIT DETAILS
        // WHILE CHAT BOX IS PULLING MESSAGES

        this.$rootScope.$broadcast('messages:pulled', {
          num_unread_from: this.metaData.num_unread_from,
        });
        var lastMessage = this.messages.length;

        if (lastMessage > 0) {
          this.beforeCursor = this.messages[lastMessage - 1].id;
        }

        this.startPollingMessages();
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  hasMoreMessages() {
    return this.metaData && this.messages.length < this.metaData.total;
  }

  sendMessage() {
    if (!this.message || !this.message.trim()) {
      return;
    }

    this.sending = true;
    if (this.BOD_2715) {
      this.Messages.sendMessage(this.patientId, this.message, 'message')
        .then(() => {
          /* TODO
        when the sendMessage will return
        the whole new save message obj just replace newMessage with res.content :)
        */

          // this.markAsRead();
          // this.messages.unshift({
          //   category_name: null,
          //   entry_type: 'message',
          //   incoming: false,
          //   id: this.messages.length && this.messages[0].id++ || 0,
          //   read: false,
          //   content: newMessage,
          //   sent: new Date(),
          //   from: {
          //     id: this.Auth.profile.id,
          //     firstname: this.Auth.profile.firstname,
          //     lastname: this.Auth.profile.lastname
          //   }
          // });
          this.markAsRead();
          this.message = null;
          this.scrollChatbox();
        })
        .catch(() => {
          this.toastr.error('Failed to send message.');
        })
        .finally(() => {
          this.sending = false;
        })
        .then(() => {
          this.refreshChatWindowMessages();
        });
    } else {
      this.Messages.sendMessage(this.patientId, this.message, 'message')
        .then(() => {
          this.markAsRead();
          this.messages.unshift({
            category_name: null,
            entry_type: 'message',
            incoming: false,
            id: (this.messages.length && this.messages[0].id++) || 0,
            read: false,
            content: this.message,
            sent: new Date(),
            from: {
              id: this.Auth.profile.id,
              firstname: this.Auth.profile.firstname,
              lastname: this.Auth.profile.lastname,
            },
          });
          this.message = null;
          this.scrollChatbox();
        })
        .catch(() => {
          this.toastr.error('Failed to send message.');
        })
        .finally(() => {
          this.sending = false;
        });
    }
  }

  markAsRead() {
    var this2 = this;
    var unreadMessages = this.messages.filter(m => (m.from.id === this.patientId ? !m.read : false));

    if (unreadMessages.length) {
      this.marking = true;
      this.Messages.markThreadAsRead(this.patientId)
        .then(() => {
          _.each(unreadMessages, m => {
            m.read = true;
          });

          this2.$rootScope.$broadcast('message-thread-read', this.patientId);
          this2.$rootScope.$broadcast('message-center:refresh'); // this2.$timeout(() => {
          //   this2.refreshChatWindowMessages();
          // }, 500);
        })
        .catch(() => this.toastr.error('Failed to mark messages as read.'))
        .finally(() => {
          this.marking = false;
        });
    }
  }

  startPollingMessages() {
    // Get outta here if we're already polling
    if (this.pollingInterval) {
      return;
    }

    this.pollingInterval = this.$interval(() => {
      this.Messages.getThread(this.patientId, {
        after: this.afterCursor,
      }).then(({ data }) => {
        this.metaData = data['metadata']; // THIS IS TO REFRESH PIMS "new message icon" IN THE VISIT DETAILS
        // WHILE CHAT BOX IS PULLING MESSAGES

        this.$rootScope.$broadcast('messages:pulled', {
          num_unread_from: this.metaData.num_unread_from,
        });

        if (this.messages.length > 0) {
          this.afterCursor = this.messages[0].id;
        }

        _.each(
          _.filter(data.data, m => {
            return m.id > this.messages[0].id && m.from.id === this.patientId;
          }),
          m => {
            this.messages.unshift(m);
            this.scrollChatbox();
          },
        );
      });
    }, this.POLL_INTERVAL);
  }

  getCategories() {
    // this.categoryName =[];
    this.Messages.getCategories().then(({ data }) => {
      this.categoryName = data; // data.forEach((eachCategory) => {
      //   this.categoryName.push(eachCategory);
      // });
    });
  }

  saveCategory(id, category_id) {
    var this2 = this;
    this.categoryName.forEach(eachcategory => {
      if (eachcategory.id == category_id) {
        this.assignCategoryName = eachcategory.name;
      }
    });
    this.messages.forEach(eachMessage => {
      if (eachMessage.id == id) {
        eachMessage.category_name = this.assignCategoryName;
      }
    });
    this.Messages.messageCategoryUpdate(id, category_id).then(() => {
      this2.$rootScope.$broadcast('message-center:refresh');
    });
  }

  editCategory(message_id) {
    this.messages.forEach(eachMessage => {
      if (eachMessage.id == message_id) {
        eachMessage.tempMessageCategoryName = null;
        eachMessage.category_name = null;
      }
    });
  }

  markRead(message_id, read_at) {
    var this2 = this;

    if (read_at !== null) {
      this.read_at = null;
    } else {
      this.read_at = 'now';
    }

    this.messages.forEach(eachMessage => {
      if (eachMessage.id == message_id) {
        eachMessage.read = this.read_at;
      }
    });
    this.Messages.messageReadUpdate(message_id, this.read_at).then(({}) => {
      this2.$rootScope.$broadcast('message-center:refresh'); // this2.$timeout(() => {
      //   this2.refreshChatWindowMessages();
      // }, 500);
    });
  }

  initChatbox() {
    this.chatBox = $('.chat-modal .ngdialog-content')
      .draggable({
        // handle: '.dialog-header',
        handle: '.chat-handler',
        scroll: false,
      })
      .resizable({
        containment: 'parent',
        handles: 'se',
      }); // THIS IS TO ACTIVATE CSS FUNCTIONS "addClass" / "removeClass" WITH RESIZE METHOD

    this.$timeout(() => {
      var height = $('#chat-dialog-header').parent().height();
      $('#chat-dialog-header')
        .parent()
        .css('height', height + 1);
    }, 500);
  }

  scrollChatbox() {
    // this.$timeout(() => { angular.element('.chat-box').stop().animate({ scrollTop: 0 }); });
  }
}
ChatController.$inject = [
  '$rootScope',
  '$scope',
  '$timeout',
  '$interval',
  'toastr',
  'Messages',
  'Users',
  'Auth',
  '$state',
  '$filter',
];
angular.module('pims').controller('ChatController', ChatController);
